import { React, useState } from "react";
import './bookingShared.css';
import './bookingStep2.css';

export default function BookingStep2({ onNext, onBack }) {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState({});

  function handleSubmit(e) {
    e.preventDefault();
    const newErrors = {};
    if (!fullName.trim()) newErrors.fullName = "Please enter your full name.";
    if (!email.trim()) newErrors.email = "Please enter your email address.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      newErrors.email = "Please enter a valid email address.";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    onNext({ fullName, email, phone });
  }

  return (
    <form className="bookingForm" onSubmit={handleSubmit} noValidate>

      <div className="bookField">
        <label className="bookLabel" htmlFor="fullName">
          Full Name <span className="req">*</span>
        </label>
        <div className="inputWithIcon">
          <input
            id="fullName"
            type="text"
            className={errors.fullName ? "inputError" : ""}
            placeholder="Enter your full name"
            value={fullName}
            onChange={(e) => {
              setFullName(e.target.value);
              setErrors((prev) => ({ ...prev, fullName: undefined }));
            }}
          />
        </div>
        {errors.fullName && <p className="fieldError">{errors.fullName}</p>}
      </div>

      <div className="bookField">
        <label className="bookLabel" htmlFor="email">
          Email Address <span className="req">*</span>
        </label>
        <div className="inputWithIcon">
          <input
            id="email"
            type="email"
            className={errors.email ? "inputError" : ""}
            placeholder="your@email.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setErrors((prev) => ({ ...prev, email: undefined }));
            }}
          />
        </div>
        {errors.email
          ? <p className="fieldError">{errors.email}</p>
          : <p className="fieldHint">Confirmation will be sent to this email</p>
        }
      </div>

      <div className="bookField">
        <label className="bookLabel" htmlFor="phone">
          Phone Number <span className="optional">(Optional)</span>
        </label>
        <div className="inputWithIcon">
          <input
            id="phone"
            type="tel"
            placeholder="+20 xxx xxx xxxx"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
      </div>
      
      <div className="formFooter">
        <button type="button" className="backBtn" onClick={onBack}>Back</button>
        <button type="submit" className="nextBtn">Next</button>
      </div>

    </form>
  );
}